'use client';

import React from 'react';

// ─── MONOLYTH VR SECTION ─────────────────────────────────────────────────────
// Extracted from Behance gallery: https://www.behance.net/gallery/112291665/Monolyth-(VR)
// Correct order per Behance:
//   1. Monolyth VR heading
//   2. Environments heading + 360 panorama (Pittsburgh)
//   3. Stills heading + Stills image grid
//   4. "Concept Environment Stills" heading + description + Concept stills grid
//   5. 360 environment embed (Detroit)

const STILLS_IMAGES = [
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/1a3a92112291665.67fbabb8975ac.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/060d80112291665.67fbabb895bef.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/c91c58112291665.67fbabb898793.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/298748112291665.67fbabb895592.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/4489ce112291665.67fbabb894f76.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/321ddf112291665.67fbabb894019.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/019f2a112291665.67fbabb89bfc6.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/7221d0112291665.67fbabb8981ad.jpg',
];

const CONCEPT_STILLS = [
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/0b1946112291665.67fbabb89c4a7.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/5c501b112291665.67fbabb898d9d.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/f1cfa3112291665.67fbabb8994f6.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/1400/3be73c112291665.67fbabb893aee.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/eaabb9112291665.67fbabb896130.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/be1fc5112291665.67fbabb894861.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/1dc877112291665.67fbabb897c88.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/49be5d112291665.67fbabb893411.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/e04fdc112291665.67fbabb89686f.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/17fc5d112291665.67fbabb89b477.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/eea906112291665.67fbabb89ad27.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/385d02112291665.67fbabb89cea3.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/e902af112291665.67fbabb899ac4.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/ab9a02112291665.67fbabb896fb2.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/35e06a112291665.67fbabb89a0d3.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/deafdb112291665.67fbabb89ba17.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/d503ad112291665.67fbabb89a5ff.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/0a4611112291665.67fbabb89dce1.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/9ec022112291665.67fbabb89c98b.jpg',
  'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/54193f112291665.67fbabb89d5d1.jpg',
];

export default function MonolythVRSection() {
  return (
    <section id="monolyth-vr" style={{ backgroundColor: '#fff' }}>
      {/* ── 1. MONOLYTH VR HEADING ── */}
      <div style={{ padding: '40px 7.1% 0', marginBottom: 20 }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#191919',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 36,
            fontWeight: 700,
            lineHeight: '1.1em',
          }}>Monolyth VR</span>
        </div>
      </div>
      {/* ── 2. ENVIRONMENTS HEADING ── */}
      <div style={{ padding: '0 7.1%', marginBottom: 12 }}>
        <div style={{ textAlign: 'center' }}>
          <a
            href="https://www.behance.net/gallery/216488169/25-Environments"
            target="_blank"
            rel="nofollow noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <span style={{
              color: '#ffc323',
              fontFamily: 'helvetica, arial, sans-serif',
              fontSize: 30,
              fontWeight: 700,
            }}>Environments</span>
          </a>
        </div>
      </div>
      {/* 360 instructions */}
      <div style={{ padding: '0 7.1%', marginBottom: 16 }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#292929',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 16,
            fontWeight: 700,
          }}>
            Click and Drag — Look Around&nbsp;&nbsp;Pinch and scroll — Zoom&nbsp;&nbsp;&apos;Open New Tab&apos; — Full Immersion
          </span>
        </div>
      </div>
      {/* Pittsburgh 360 panorama */}
      <div style={{ marginBottom: 4 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/ju9H2Q0.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Pittsburgh · Braddock Environment · 360° Panorama"
          />
        </div>
      </div>
      {/* ── 3. STILLS HEADING ── */}
      <div style={{ padding: '20px 7.1% 16px' }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#696969',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 20,
            fontWeight: 400,
          }}>Stills</span>
        </div>
      </div>
      {/* Stills grid — 2 columns (first 4) */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, marginBottom: 4 }}>
        {STILLS_IMAGES?.slice(0, 4)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden', aspectRatio: '16/9' }}>
            <img
              src={src}
              alt={`Monolyth environment still ${i + 1}`}
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          </div>
        ))}
      </div>
      {/* Full-width still */}
      <div style={{ marginBottom: 4 }}>
        <img
          src={STILLS_IMAGES?.[4]}
          alt="Monolyth environment still 5"
          style={{ width: '100%', display: 'block' }}
        />
      </div>
      {/* 3-column stills */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 4, marginBottom: 20 }}>
        {STILLS_IMAGES?.slice(5, 8)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden', aspectRatio: '4/3' }}>
            <img
              src={src}
              alt={`Monolyth environment still ${i + 6}`}
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          </div>
        ))}
      </div>
      {/* ── 4. CONCEPT ENVIRONMENT STILLS HEADING ── */}
      <div style={{ padding: '0 7.1%', marginBottom: 16 }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#696969',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 20,
            fontWeight: 400,
          }}>Concept Environment Stills</span>
          <br />
          <span style={{
            color: '#696969',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 15,
            fontWeight: 400,
          }}>
            Assets and structures I&apos;ve already built out for the open world landscape I&apos;m currently designing to place them in.
          </span>
        </div>
      </div>
      {/* Concept stills — 2-col (first 4) */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, marginBottom: 4 }}>
        {CONCEPT_STILLS?.slice(0, 4)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`Monolyth concept still ${i + 1}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      {/* Full-width concept still */}
      <div style={{ marginBottom: 4 }}>
        <img src={CONCEPT_STILLS?.[4]} alt="Monolyth concept still 5" style={{ width: '100%', display: 'block' }} />
      </div>
      {/* 3-col concept stills */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 4, marginBottom: 4 }}>
        {CONCEPT_STILLS?.slice(5, 8)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`Monolyth concept still ${i + 6}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      {/* 2fr/1fr concept stills */}
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 4, marginBottom: 4 }}>
        {CONCEPT_STILLS?.slice(8, 10)?.map((src, i) => (
          <div key={i} style={{ overflow: 'hidden' }}>
            <img src={src} alt={`Monolyth concept still ${i + 9}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      {/* Remaining concept stills */}
      <div style={{ marginBottom: 4 }}>
        {CONCEPT_STILLS?.slice(10)?.map((src, i) => (
          <div key={i} style={{ marginBottom: 4 }}>
            <img src={src} alt={`Monolyth concept still ${i + 11}`} style={{ width: '100%', display: 'block' }} />
          </div>
        ))}
      </div>
      {/* ── 5. 360 ENVIRONMENT EMBED (Detroit) ── */}
      <div style={{ padding: '20px 7.1% 8px' }}>
        <div style={{ textAlign: 'center', marginBottom: 12 }}>
          <span style={{
            color: '#292929',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 16,
            fontWeight: 700,
          }}>
            Click and Drag — Look Around&nbsp;&nbsp;Pinch and scroll — Zoom&nbsp;&nbsp;&apos;Open New Tab&apos; — Full Immersion
          </span>
        </div>
      </div>
      <div style={{ marginBottom: 20 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/qHMruBB.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Detroit Environment · 360° Panorama"
          />
        </div>
      </div>
    </section>
  );
}
